// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TK4C4","index":"styles_index__2j5IJ"};